import { EsimOrderCode, EsimOrderProvisioningStatus } from 'src/xm/esim/constants';
import { ModelBase } from 'store/model-base';

export class EsimOrderStatus extends ModelBase {
    public static storeName: string = 'esimOrderStatus';

    public orderId: string;
    public orderKey: string;
    public status: EsimOrderCode;
    public provisioningStatus: EsimOrderProvisioningStatus;
    public errorInfo: EsimOrderStatusError;
    public additionalInfo: EsimOrderStatusAdditionalInfo;
}
